/**
 * Created by Geetha on 5/21/2020.
 */
'use strict';
import angular from 'angular';
import quickViewController from './quickView.controller';
var AlternateProductCardController = /** @class */ (function () {
    /*@ngInject*/
    function AlternateProductCardController(CartService, $scope, $mdDialog, $location, ProductService, $filter, UserService, CommonDataService, $rootScope, $window, $timeout, $state, googleAnalytic) {
        var _this = this;
        this.itemDetail = {};
        this.searchText = '';
        this.scope = '';
        this.displayPopup = false;
        this.multipleOf = false;
        this.oldPurchaseQuantity = 1;
        this.hasCondition = false;
        this.selectedItem = null;
        this.selectedItemInventory = null;
        this.expectedDeliverDate = '';
        this.totalStock = 0;
        this.disableCartBtn = function () {
            var isDisable = false;
            var inventory = _this.setInventoryData();
            //put logic here to determine if the Add to Cart button should be disabled
            if (!_this.practitionerUser && !_this.patientUser)
                isDisable = true;
            else if ((_this.itemDetail.inventory && _this.itemDetail.inventory.length) &&
                ((inventory.vendorBackOrder || _this.itemDetail.isDiscontinued) && inventory.stock <= 0)
                || _this.itemDetail.isRestricted) {
                isDisable = true;
            }
            else if (_this.addingToCart)
                isDisable = true;
            return isDisable;
        };
        this.showAddedToCartPopup = function () {
            _this.displayPopup = true;
            _this.$timeout(function () {
                _this.displayPopup = false;
            }, 4000);
        };
        var self = this;
        this.$mdDialog = $mdDialog;
        this.scope = $scope;
        this.productService = ProductService;
        this.cart = CartService;
        this.$state = $state;
        this.CommonDataService = CommonDataService;
        this.CommonDataService.addAttributeProductPathsForSingleItem(self.config);
        this.product = self.config;
        this.purchaseNumber = 1;
        this.$filter = $filter;
        this.userService = UserService;
        this.$timeout = $timeout;
        this.$window = $window;
        this.user = {};
        var date = new Date();
        this.currentDate = date.getFullYear() + '-' + date.getMonth() + '-' + date.getDate() + 'T' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
        this.$scope = $scope;
        this.ga = googleAnalytic;
        $scope.purchaseQuantity = 1;
        // $scope.inventory = {};
        /*this.outOfStockMessage = */
        //if there is unique search term, check if it match the itemCode and set up the dropdown index
        // $scope.selectItemNum = 0;
        var isTemporaryHeatSensitiveItem = function () {
            var dateNow = new Date();
            var from_date = Date.parse(new Date(dateNow.getFullYear(), 3, 1)); // the month is 0-based
            var to_date = Date.parse(new Date(dateNow.getFullYear(), 8, 30)); // the month is 0-based
            var today = Date.parse(dateNow);
            if (today > from_date && today < to_date) {
                return true;
            }
            else {
                return false;
            }
        };
        this.userService.get().then(function (user) {
            if (user !== null && user !== undefined && user.status !== 401) {
                _this.user = user.data.response;
                _this.isUserloggedIn = true;
                if (_this.user.accountType === 'Practitioner') {
                    _this.practitionerUser = true;
                }
                else if (_this.user.accountType === 'Patient') {
                    _this.patientUser = true;
                }
            }
            else
                _this.isUserloggedIn = false;
        });
        $scope.addingToCart = null;
        $scope.addToCartResponse = null;
        this.addingToCartDialog = {
            template: "\n        <md-dialog class=\"cart-summary-dialog\">\n          <cart-summary-dialog adding-to-cart=\"addingToCart\"\n                               item=\"item\"\n                               response=\"addToCartResponse\"\n                               quantity=\"purchaseQuantity\"\n                               limited-stock=\"limitedStock\"></cart-summary-dialog>\n        </md-dialog>\n      ",
            scope: $scope,
            preserveScope: true,
            clickOutsideToClose: false,
            escapeToClose: false,
            fullscreen: false
        };
        $scope.isTemporaryHeatSensitiveItem = isTemporaryHeatSensitiveItem();
        /*quantity dropdown*/
        $scope.currentIndex = null;
        $scope.closeThis = closeThis;
        $scope.setCurrentItem = setCurrentItem;
        function closeThis() {
            $scope.currentIndex = null;
        }
        function setCurrentItem(itemId) {
            if (itemId == $scope.currentIndex) {
                $scope.currentIndex = null;
            }
            else {
                $scope.currentIndex = itemId;
            }
        }
        $scope.clearQuantity = function (purchaseNumber) {
            if (purchaseNumber) {
                _this.purchaseNumber = '';
            }
            else {
                $scope.purchaseQuantity = '';
            }
        };
        $scope.viewSimilarProducts = function () {
            self.productService.gotoAlternateProduct = true;
            $location.path('/products/detail/' + self.config.attributeNamePath + '/' + self.config.productNamePath + '/' + self.config.productId + '/' + _this.selectedItem.itemCode); // self.config.items[$scope.selectItemNum].itemCode)
        };
        $scope.$watch('$ctrl.selectedItem', function (num) {
            if (self.selectedItem.hasOwnProperty('items')) {
                self.itemDetail = self.selectedItem.items[num];
            }
        });
        self.updateQuantity = function (e) {
            this.itemDetail.quantity = e.item.quantity;
        };
        $scope.displayQuickView = function (ev) {
            $mdDialog.show({
                controller: quickViewController,
                controllerAs: 'vm',
                locals: {
                    productId: self.config.productId,
                    itemCode: self.selectedItem.itemCode,
                    parentItem: self.config.items,
                    currentDate: self.currentDate,
                },
                template: require('./quickView.html'),
                parent: angular.element(document.querySelector('quick-view-overlay')),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: false,
                onShowing: function () {
                    $rootScope.saveTopValOnModalOpen();
                },
                onRemoving: function () {
                    $rootScope.retainPosOnModalClose();
                }
            });
        };
    }
    AlternateProductCardController.prototype.$onInit = function () {
        this.selectedItem = this.config.items[0];
        this.setSelectedItem();
        this.setInventoryData();
        this.checkForCondition();
    };
    AlternateProductCardController.prototype.setSelectedItem = function () {
        var _this = this;
        if (!!this.itemCode) {
            var filteredList = this.config.items.filter(function (item) { return item.itemCode.toUpperCase() === _this.itemCode.toUpperCase(); });
            if (filteredList.length > 0) {
                this.selectedItem = filteredList[0];
            }
            return;
        }
        this.selectedItem = this.config.items.filter(function (item) { return item.inventory.some(function (inv) { return inv.stock > 0 && inv.isDefault; }); })[0];
    };
    AlternateProductCardController.prototype.checkForCondition = function () {
        var isHeatSensitive = this.config.isHeatSensitive || (this.config.isTempHeatSensitive && this.$scope.isTemporaryHeatSensitiveItem);
        var isProp65Restriction2 = this.selectedItem.prop65Restriction === 2 && !this.selectedItem.prop65AlternativeItemId;
        var isProp65Restriction3 = this.selectedItem.prop65Restriction === 3 && !this.selectedItem.prop65AlternativeItemId;
        if (this.selectedItem.specialOrder ||
            (this.selectedItemInventory && this.selectedItemInventory.shortShelfLife) ||
            isHeatSensitive ||
            isProp65Restriction2 ||
            isProp65Restriction3) {
            this.hasCondition = true;
        }
        else {
            this.hasCondition = false;
        }
    };
    AlternateProductCardController.prototype.setInventoryData = function () {
        var _this = this;
        var stocks = [];
        var vendorBackOrder = true;
        var backOrder = true;
        if (this.selectedItem.inventory && this.selectedItem.inventory.length) {
            this.selectedItem.inventory.forEach(function (arr) {
                _this.totalStock += arr.stock;
                stocks.push(arr.stock);
                if (arr.isDefault) {
                    _this.selectedItemInventory = arr;
                    vendorBackOrder = vendorBackOrder && arr.vendorBackOrder;
                    backOrder = backOrder && arr.backOrder;
                    var currentDate = new Date();
                    var deliverDate = _this.$filter('date')(arr.expectedDeliverDate, 'MM/dd/yyyy');
                    var expectedDeliverDate = new Date(arr.expectedDeliverDate);
                    if (expectedDeliverDate === null || expectedDeliverDate < currentDate || vendorBackOrder) {
                        _this.outOfStockMessage = 'Out of Stock ';
                    }
                    else {
                        _this.expectedDeliverDate = deliverDate;
                        _this.outOfStockMessage = 'Back in Stock ' + deliverDate;
                    }
                }
            });
            // why am I doing this in 5 places???
            this.selectedItemInventory.stock = (stocks || []).length > 0 ? Math.max.apply(null, stocks) : 0;
            this.selectedItemInventory.vendorBackOrder = vendorBackOrder;
            this.selectedItemInventory.backOrder = backOrder;
        }
        else {
            this.selectedItemInventory = this.selectedItem.inventory[0];
        }
    };
    AlternateProductCardController.prototype.closeMultipleMsg = function () {
        this.multipleOf = false;
    };
    AlternateProductCardController.prototype.showDetailpage = function () {
        this.ga.sendEvent('Customer', 'Alternate Product', 'Clicks on "Alternate Product" at the bottom of the PDP', 1);
        sessionStorage.setItem('prevOffset', this.$window.pageYOffset);
    };
    AlternateProductCardController.prototype.addtoCartfn = function (itemCode) {
        var _this = this;
        this.itemDetail.quantity = this.itemDetail.quantity ? this.itemDetail.quantity : 1;
        if (!this.purchaseNumber) {
            return false;
        }
        if (itemCode !== '' || itemCode !== undefined) {
            this.addingToCart = true;
            this.cart.addItemQuantity(itemCode, this.itemDetail.quantity)
                .then(function (data) {
                _this.showAddedToCartPopup();
                _this.$scope.addToCartResponse = data;
            })
                .catch(function (reason) {
                _this.$scope.addToCartResponse = { error: true, reason: reason };
            })
                .finally(function () {
                _this.addingToCart = false;
            });
        }
    };
    return AlternateProductCardController;
}());
export default AlternateProductCardController;
//# sourceMappingURL=alternate-product-card.controller.js.map